import { render, staticRenderFns } from "./LevelQualityCard.vue?vue&type=template&id=deba297e&scoped=true"
import script from "./LevelQualityCard.vue?vue&type=script&lang=js"
export * from "./LevelQualityCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deba297e",
  null
  
)

export default component.exports